import SubmissionsContainer from "./SubmissionsContainer";

export default SubmissionsContainer;
